export default __webpack_public_path__ + "7733cc1de7c1ebb2f7d9ea47deb7f1b0.svg";